import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";

export default function DoctrineDetail() {
  const { slug } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api
      .get(`/doctrines/${slug}`)
      .then((r) => setD(r.data))
      .catch(() => setErr(true));
  }, [slug]);

  if (err) return <NotFoundInline />;
  if (!d) return <div className="container-reading py-24 text-ink-muted">Loading…</div>;

  return (
    <article>
      <header className="bg-subtle border-b border-border py-20">
        <div className="container-reading">
          <Link to="/what-we-believe" className="eyebrow text-forest hover:underline">← Statement of Faith</Link>
          <h1 className="heading-1 mt-6">{d.title}</h1>
          <p className="lead mt-6">{d.summary}</p>
        </div>
      </header>
      <div className="container-reading py-16 sm:py-20 prose-editorial">
        <p>{d.body}</p>
        {d.key_scriptures?.length > 0 && (
          <div className="my-10 border-l-2 border-gold pl-6">
            <p className="eyebrow">Key Scriptures</p>
            <p className="mt-2 text-ink">{d.key_scriptures.join(" · ")}</p>
          </div>
        )}
        <p className="text-sm text-ink-muted">Reviewed by {d.reviewer_name || "Anant Jeevan Elder Team"}.</p>
      </div>
    </article>
  );
}

function NotFoundInline() {
  return (
    <div className="container-reading py-24 text-center">
      <h1 className="heading-2">Doctrine not found.</h1>
      <Link to="/what-we-believe" className="mt-6 btn-primary inline-flex">Back to Statement of Faith</Link>
    </div>
  );
}
